import React from 'react';
import { LayoutDashboardIcon, MapIcon, FilePlusIcon, FileTextIcon, BellIcon, BarChart3Icon, DatabaseIcon, UsersIcon, SettingsIcon, ChevronLeftIcon, ChevronRightIcon, BuildingIcon } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { ViewType } from '../../data/types';
interface NavItem {
  id: ViewType;
  label: string;
  labelBn: string;
  icon: React.ReactNode;
  adminOnly?: boolean;
}
const navItems: NavItem[] = [{
  id: 'dashboard',
  label: 'Dashboard',
  labelBn: 'ড্যাশবোর্ড',
  icon: <LayoutDashboardIcon className="w-5 h-5" data-id="element-56" />
}, {
  id: 'land-records',
  label: 'Land Records',
  labelBn: 'ভূমি রেকর্ড',
  icon: <MapIcon className="w-5 h-5" data-id="element-57" />
}, {
  id: 'create-record',
  label: 'Create New Record',
  labelBn: 'নতুন রেকর্ড তৈরি',
  icon: <FilePlusIcon className="w-5 h-5" data-id="element-58" />
}, {
  id: 'documents',
  label: 'Documents',
  labelBn: 'দলিলপত্র',
  icon: <FileTextIcon className="w-5 h-5" data-id="element-59" />
}, {
  id: 'notifications',
  label: 'Notifications',
  labelBn: 'বিজ্ঞপ্তি',
  icon: <BellIcon className="w-5 h-5" data-id="element-60" />
}, {
  id: 'reports',
  label: 'Reports',
  labelBn: 'রিপোর্ট',
  icon: <BarChart3Icon className="w-5 h-5" data-id="element-61" />
}, {
  id: 'master-data',
  label: 'Master Data',
  labelBn: 'মাস্টার ডেটা',
  icon: <DatabaseIcon className="w-5 h-5" data-id="element-62" />,
  adminOnly: true
}, {
  id: 'users-roles',
  label: 'Users & Roles',
  labelBn: 'ব্যবহারকারী ও ভূমিকা',
  icon: <UsersIcon className="w-5 h-5" data-id="element-63" />,
  adminOnly: true
}, {
  id: 'settings',
  label: 'Settings',
  labelBn: 'সেটিংস',
  icon: <SettingsIcon className="w-5 h-5" data-id="element-64" />
}];
export function Sidebar() {
  const {
    state,
    dispatch,
    navigate,
    canAccessMasterData,
    canAccessUsersRoles,
    canCreate
  } = useApp();
  const {
    currentView,
    language,
    sidebarCollapsed,
    notifications
  } = state;
  const unreadCount = notifications.filter(n => !n.read).length;
  const filteredNavItems = navItems.filter(item => {
    if (item.id === 'master-data' && !canAccessMasterData()) return false;
    if (item.id === 'users-roles' && !canAccessUsersRoles()) return false;
    if (item.id === 'create-record' && !canCreate()) return false;
    return true;
  });
  return <aside className={`hidden md:flex flex-col bg-sidebar-bg text-white transition-all duration-300 ${sidebarCollapsed ? 'w-16' : 'w-64'}`} data-id="element-65">
      {/* Logo */}
      <div className="h-16 flex items-center px-4 border-b border-slate-700" data-id="element-66">
        <div className="flex items-center gap-3" data-id="element-67">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-68">
            <BuildingIcon className="w-5 h-5 text-white" data-id="element-69" />
          </div>
          {!sidebarCollapsed && <div className="overflow-hidden" data-id="element-70">
              <h1 className="font-semibold text-sm leading-tight" data-id="element-71">
                Incepta Pharma
              </h1>
              <p className="text-xs text-slate-400" data-id="element-72">Legal Affairs</p>
            </div>}
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-4 overflow-y-auto" data-id="element-73">
        <ul className="space-y-1 px-2" data-id="element-74">
          {filteredNavItems.map(item => {
          const isActive = currentView === item.id || item.id === 'land-records' && (currentView === 'land-record-details' || currentView === 'land-record-edit');
          return <li key={item.id} data-id="element-75">
                <button onClick={() => navigate(item.id)} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${isActive ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-sidebar-hover hover:text-white'}`} title={sidebarCollapsed ? language === 'en' ? item.label : item.labelBn : undefined} data-id="element-76">
                  <span className="flex-shrink-0 relative" data-id="element-77">
                    {item.icon}
                    {item.id === 'notifications' && unreadCount > 0 && <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-[10px] flex items-center justify-center" data-id="element-78">
                        {unreadCount}
                      </span>}
                  </span>
                  {!sidebarCollapsed && <span className="text-sm font-medium truncate" data-id="element-79">
                      {language === 'en' ? item.label : item.labelBn}
                    </span>}
                </button>
              </li>;
        })}
        </ul>
      </nav>

      {/* Collapse Toggle */}
      <div className="p-2 border-t border-slate-700" data-id="element-80">
        <button onClick={() => dispatch({
        type: 'TOGGLE_SIDEBAR'
      })} className="w-full flex items-center justify-center gap-2 px-3 py-2 text-slate-400 hover:text-white hover:bg-sidebar-hover rounded-lg transition-colors" data-id="element-81">
          {sidebarCollapsed ? <ChevronRightIcon className="w-5 h-5" data-id="element-82" /> : <>
              <ChevronLeftIcon className="w-5 h-5" data-id="element-83" />
              <span className="text-sm" data-id="element-84">Collapse</span>
            </>}
        </button>
      </div>
    </aside>;
}